module.exports = __webpack_public_path__ + "static/media/logout.f57b0fe6.svg";